module.exports = __webpack_public_path__ + "img/4.b33df657.jpg";